import { render, staticRenderFns } from "./CleansingV2.vue?vue&type=template&id=56b1c18d&"
import script from "./CleansingV2.vue?vue&type=script&lang=js&"
export * from "./CleansingV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports